import { PayloadAction } from '@reduxjs/toolkit';
import { put, select, takeLatest } from 'redux-saga/effects';
import { SchemaApiValue } from '../../@shared/Models/Models';
import { getOpenedSchema } from '../../reducers/data/dataReducer';
import { NotificationModel } from '../../reducers/main/mainModel';
import { UpdateSchemaItem } from '../../reducers/schema/schema';
import { addEmptySchemaItem, cleanSchema, removeSchemaItems, setIsShowSchemaModal, setSchemaDescription, setSchemaId, setSchemaName, setSchemaItems, updateSchemaItems } from '../../reducers/schema/schemaReducer';
import { onThrowAlert} from '../dataSaga/dataSagaActions';

import { openModelModalAction, closeModelModalAction, addStructureItem, removeStructureItem, updateStructureItem, openEditSchemaAction } from './modelSagaActions';

const initSaga = [
    takeLatest(openModelModalAction, watchOpening),
    takeLatest(openEditSchemaAction, watchEditOpening),
    takeLatest(closeModelModalAction, watchCloasing),
    takeLatest(addStructureItem, watchAddingStructureItem),
    takeLatest(updateStructureItem, watchUpdatingStructureItem),
    takeLatest(removeStructureItem, watchRemovingStructureItem),
]

export default initSaga;

function* watchOpening(): Generator {
    try {
        yield put(setIsShowSchemaModal(true));
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
    }
}

function* watchEditOpening({ payload: data }: PayloadAction<string>): Generator {
    try {

        const schema = (yield select(getOpenedSchema)) as SchemaApiValue;
        yield put(setSchemaId(data));
        yield put(setSchemaItems(schema.schemaItems));
        yield put(setSchemaName(schema.name));
        yield put(setSchemaDescription(schema.description));
        yield put(setIsShowSchemaModal(true));
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
    }
}

function* watchCloasing(): Generator {
    try {
        yield put(setIsShowSchemaModal(false));
        yield put(cleanSchema());
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
    }
}

function* watchAddingStructureItem(): Generator {
    try {
        yield put(addEmptySchemaItem());
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
    }
}

function* watchUpdatingStructureItem({ payload: data }: PayloadAction<UpdateSchemaItem>): Generator {
    try {
        yield put(updateSchemaItems(data));
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
    }
}

function* watchRemovingStructureItem({ payload: data }: PayloadAction<number>): Generator {
    try {
        yield put(removeSchemaItems(data));
    }
    catch (error) {
        yield put(onThrowAlert({
            message: (error as Error).message,
            lifeTime: 10000
        } as NotificationModel));
    }
}